import React from 'react';
import TableFilters from "../TableFilters";
import DataTable from '../DataTable';
import {taxAuthorityColumns} from "../../../../../../common/constants/gridColumns";

const DataTableWithFiltersView = ({
                                    search,
                                    data = [],
                                    getListForExcel,
                                    options,
                                    customClassNames = {},
                                    columns,
                                    totalPages,
                                    totalResults,
                                    ...rest
                                  }) => {

  return (
    <>
      <TableFilters
        search={search}
        options={options}
        getListForExcel={getListForExcel}
        {...rest}
      />
      <DataTable
        data={data}
        columnsList={taxAuthorityColumns}
        customClassNames={customClassNames}
        totalPages={totalPages}
        totalResultCount={totalResults}
        {...rest}
      />
    </>
  )
};

export default DataTableWithFiltersView;